/*
 * @Descripttion: 场景管理统一列定义（详情表格公共列，两端共用）
 * @Date: 2026-08-11 00:00:00
 */
import { useTableColumn } from 'xrk-components';
import { formatter } from '@/utils';

/** 序号列 */
export const indexCol = useTableColumn({
  type: 'index',
  label: '序号',
  width: 60
});

/** 详情展开列（💡推荐理由 / 🎯输出成果） */
export const expandDetailCol = useTableColumn({
  type: 'expand',
  label: '详情',
  width: 70,
  render: ({ row }: { row: any }) => (
    <div class="reason-expand">
      <span class="reason-expand__item">
        <span class="reason-expand__icon">💡</span>
        推荐理由：{row.sceneObjective || '--'}
      </span>
      <span class="reason-expand__item">
        <span class="reason-expand__icon">🎯</span>
        输出成果：{row.coreKpi || '--'}
      </span>
    </div>
  )
});

/** 关联产品列（只展示产品名称） */
export const linkedProductCol = useTableColumn({
  label: '关联产品',
  prop: 'products',
  minWidth: 250,
  render: ({ row }: { row: any }) => {
    const list = row.products || [];
    if (!list.length) return <span>--</span>;
    return (
      <div class="linked-products">
        {list.map(p => (
          <div class="linked-product">
            <b>{p.productName || '--'}</b>
          </div>
        ))}
      </div>
    );
  }
});

/** 场景名称列（内容过滤用 formatter，defaultFormat 处理空值显示 -） */
export const sceneNameCol = useTableColumn({
  label: '场景名称',
  prop: 'sceneName',
  minWidth: 270,
  formatter: ({ cellValue }) => formatter.defaultFormat(cellValue)
});

/** 备案类型列（defaultFormat 处理空值显示 -） */
export const medicalRepTagCol = useTableColumn({
  label: '备案类型',
  prop: 'medicalRepTag',
  width: 100,
  formatter: ({ cellValue }) => formatter.defaultFormat(cellValue)
});

/** 终端渠道/服务对象列 */
export const terminalServiceCol = useTableColumn({
  label: '终端渠道/服务对象',
  prop: 'terminalChannel',
  minWidth: 210,
  render: ({ row }: { row: any }) => (
    <div class="terminal-service-cell">
      <div>
        <span style="color:#8a9099">终端渠道：</span>
        {row.terminalChannel || '—'}
      </div>
      <div>
        <span style="color:#8a9099">服务对象：</span>
        {row.serviceObject || '—'}
      </div>
    </div>
  )
});

/** 服务简介列 */
export const projectIntroCol = useTableColumn({
  label: '服务简介',
  prop: 'projectIntroduction',
  minWidth: 200,
  formatter: ({ cellValue }: { cellValue: string }) => cellValue || '--'
});

/**
 * 平台价格区间列（金额元，translators 层已分转元；直接展示）
 */
export const platformPriceCol = useTableColumn({
  label: '平台价格区间',
  prop: 'platformPriceLower',
  width: 160,
  renderHeader: () => (
    <div style="text-align:left">
      <div>平台价格区间</div>
      <div style="font-size:12px;color:#9aa2ad">（项目结算单价）</div>
    </div>
  ),
  formatter: ({ row }: { row: any }) =>
    row.platformPriceLower == null || row.platformPriceUpper == null
      ? '-'
      : `${row.platformPriceLower} ~ ${row.platformPriceUpper} 元`
});

/** 更新时间列 */
export const updateDtCol = useTableColumn({
  label: '更新时间',
  prop: 'updateDt',
  width: 170,
  formatter: ({ cellValue }: { cellValue: string }) => formatter.date(cellValue)
});
